// This file is auto-generated by scripts/generate-registry.ts
// Do not edit manually - your changes will be overwritten

import { PageMetadata } from '@/types/page'

import * as ApiReference from '@/pages/ApiReference'
import * as api_Embed from '@/pages/api/Embed'
import * as api_Floating from '@/pages/api/Floating'
import * as classic_Authentication from '@/pages/classic/Authentication'
import * as classic_Customization from '@/pages/classic/Customization'
import * as classic_GuideCustom from '@/pages/classic/GuideCustom'
import * as customization_Colors from '@/pages/customization/Colors'
import * as customization_CustomLauncher from '@/pages/customization/CustomLauncher'
import * as customization_GetConfig from '@/pages/customization/GetConfig'
import * as customization_Layout from '@/pages/customization/Layout'
import * as customization_Minimalistic from '@/pages/customization/Minimalistic'
import * as embed_Contact from '@/pages/embed/Contact'
import * as embed_Conversational from '@/pages/embed/Conversational'
import * as embed_Draggable from '@/pages/embed/Draggable'
import * as embed_HomeScreen from '@/pages/embed/HomeScreen'
import * as embed_Intranet from '@/pages/embed/Intranet'
import * as embed_MultiColumn from '@/pages/embed/MultiColumn'
import * as embed_MultiColumnMinimalist from '@/pages/embed/MultiColumnMinimalist'
import * as embed_Overlay from '@/pages/embed/Overlay'
import * as messaging_Authentication from '@/pages/messaging/Authentication'
import * as messaging_ConversationMetadata from '@/pages/messaging/ConversationMetadata'
import * as messaging_Cookies from '@/pages/messaging/Cookies'
import * as messaging_Metadata from '@/pages/messaging/Metadata'
import * as messaging_NoBot from '@/pages/messaging/NoBot'
import * as messaging_Voice from '@/pages/messaging/Voice'
import * as proactive_Basic from '@/pages/proactive/Basic'
import * as proactive_Contact from '@/pages/proactive/Contact'
import * as proactive_French from '@/pages/proactive/French'
import * as proactive_Product from '@/pages/proactive/Product'
import * as proactive_Spanish from '@/pages/proactive/Spanish'
import * as utility_AnswerBot from '@/pages/utility/AnswerBot'
import * as utility_StorageLimits from '@/pages/utility/StorageLimits'

export const pages: PageMetadata[] = [
  { ...ApiReference.metadata, component: ApiReference.default },
  { ...api_Embed.metadata, component: api_Embed.default },
  { ...api_Floating.metadata, component: api_Floating.default },
  { ...classic_Authentication.metadata, component: classic_Authentication.default },
  { ...classic_Customization.metadata, component: classic_Customization.default },
  { ...classic_GuideCustom.metadata, component: classic_GuideCustom.default },
  { ...customization_Colors.metadata, component: customization_Colors.default },
  { ...customization_CustomLauncher.metadata, component: customization_CustomLauncher.default },
  { ...customization_GetConfig.metadata, component: customization_GetConfig.default },
  { ...customization_Layout.metadata, component: customization_Layout.default },
  { ...customization_Minimalistic.metadata, component: customization_Minimalistic.default },
  { ...embed_Contact.metadata, component: embed_Contact.default },
  { ...embed_Conversational.metadata, component: embed_Conversational.default },
  { ...embed_Draggable.metadata, component: embed_Draggable.default },
  { ...embed_HomeScreen.metadata, component: embed_HomeScreen.default },
  { ...embed_Intranet.metadata, component: embed_Intranet.default },
  { ...embed_MultiColumn.metadata, component: embed_MultiColumn.default },
  { ...embed_MultiColumnMinimalist.metadata, component: embed_MultiColumnMinimalist.default },
  { ...embed_Overlay.metadata, component: embed_Overlay.default },
  { ...messaging_Authentication.metadata, component: messaging_Authentication.default },
  { ...messaging_ConversationMetadata.metadata, component: messaging_ConversationMetadata.default },
  { ...messaging_Cookies.metadata, component: messaging_Cookies.default },
  { ...messaging_Metadata.metadata, component: messaging_Metadata.default },
  { ...messaging_NoBot.metadata, component: messaging_NoBot.default },
  { ...messaging_Voice.metadata, component: messaging_Voice.default },
  { ...proactive_Basic.metadata, component: proactive_Basic.default },
  { ...proactive_Contact.metadata, component: proactive_Contact.default },
  { ...proactive_French.metadata, component: proactive_French.default },
  { ...proactive_Product.metadata, component: proactive_Product.default },
  { ...proactive_Spanish.metadata, component: proactive_Spanish.default },
  { ...utility_AnswerBot.metadata, component: utility_AnswerBot.default },
  { ...utility_StorageLimits.metadata, component: utility_StorageLimits.default }
]

export function getPageById(id: string): PageMetadata | undefined {
  return pages.find(page => page.id === id)
}

export function getPageByPath(path: string): PageMetadata | undefined {
  return pages.find(page => page.path === path)
}

export function getPagesByCategory(category: string): PageMetadata[] {
  return pages.filter(page => page.category === category)
}

export function getAllCategories(): string[] {
  const categories = new Set(pages.map(page => page.category))
  return Array.from(categories)
}
